import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';

export const Navbar = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/potencial-energetico', label: t('nav.potential') },
    { path: '/contacto', label: t('nav.contact') },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-emerald-100/20" data-testid="main-navbar">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2" data-testid="nav-logo-link">
            <img 
              src="/logo.png" 
              alt="Paraguana Hydrogen Gateway" 
              className="h-20 md:h-24 w-auto"
              data-testid="nav-logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-slate-600 hover:text-primary-600'
                }`}
                data-testid={`nav-link-${link.path.slice(1) || 'home'}`}
              >
                {link.label}
              </Link>
            ))}

            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="px-3 py-1.5 text-sm font-medium text-slate-600 hover:text-primary-600 transition-colors"
              data-testid="language-toggle"
            >
              {language.toUpperCase()}
            </button>

            {/* CTA Button */}
            <Button 
              asChild
              className="gradient-green text-white hover:opacity-90 transition-opacity shadow-lg shadow-primary-500/30"
              data-testid="nav-cta-contact"
            >
              <Link to="/contacto">{t('nav.contact')}</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-slate-600 hover:text-primary-600"
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-6 space-y-4 border-t border-emerald-100/20" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block px-4 py-2 text-base font-medium rounded-lg transition-colors ${
                  location.pathname === link.path
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-slate-600 hover:text-primary-600 hover:bg-slate-50'
                }`}
                data-testid={`mobile-nav-link-${link.path.slice(1) || 'home'}`}
              >
                {link.label}
              </Link>
            ))}
            
            <button
              onClick={toggleLanguage}
              className="w-full px-4 py-2 text-left text-base font-medium text-slate-600 hover:text-primary-600 hover:bg-slate-50 rounded-lg transition-colors"
            >
              {language === 'es' ? 'Switch to English' : 'Cambiar a Español'}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};